import { cx } from "shared/utils";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";
import { Show } from "shared/components/helpers/Show";
import { PermittedContent } from "../../PermittedContent";

const getCellClassNames = ({
  isDataCell,
  bg,
  isFirst,
  check,
  className,
  showRestrictedFlag
}: {
  isDataCell?: boolean;
  bg?: string;
  isFirst?: boolean;
  check?: boolean | null;
  className?: string;
  showRestrictedFlag?: boolean;
}) => {
  const isColoredCell = isDataCell || bg;

  const getTextProperties = () => {
    if (isDataCell || bg) return "text-content-1000 font-medium";

    if (typeof check === "boolean")
      return check ? "text-success-700 font-bold" : "text-danger-500 font-bold";

    return "text-content-400";
  };

  return cx(
    bg,
    "md:px-6 md:py-4 p-3 h-[54px] box-border flex z-[8] text-sm md:border-r border-[#F1EFF0] max-w-[340px] transition-all",
    getTextProperties(),
    isColoredCell ? "group-hover:bg-alpha-10" : "group-hover:bg-background-800",
    showRestrictedFlag ? "relative" : "",
    !isFirst ? "!border-t-0" : "0",
    className
  );
};

export const Cell = ({
  children,
  className,
  isDataCell,
  bg,
  isFirst,
  check,
  isPermitted = true,
  showRestrictedFlag = false
}: {
  children?: React.ReactNode;
  className?: string;
  isDataCell?: boolean;
  isFirst?: boolean;
  bg?: string;
  check?: boolean | null;
  isPermitted?: boolean;
  showRestrictedFlag?: boolean;
}) => (
  <div
    className={getCellClassNames({
      isDataCell,
      bg,
      isFirst,
      check,
      className,
      showRestrictedFlag
    })}
  >
    <PermittedContent isPermitted={isPermitted}>
      <Show if={showRestrictedFlag}>
        <div className="text-content-200 bg-background-900 border-t-0 border border-alpha-40 rounded-bl-xl p-2 absolute right-0 top-0">
          Access restricted
        </div>
      </Show>
      <Show if={typeof check === "boolean"}>
        {check ? (
          <SuccessIcon className="w-4 h-4 mr-2 stroke-none text-success-600" />
        ) : (
          <FailedIcon className="w-4 h-4 mr-2 stroke-none text-danger-600" />
        )}
      </Show>
      {children}
    </PermittedContent>
  </div>
);
